import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeKeycloak } from './services/keyclock-init.service';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakBearerInterceptor } from 'keycloak-angular';
import { authInterceptor } from './interceptor/auth.interceptor';
import { FullLoaderComponent } from './components/full-loader/full-loader.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideSweetAlert2 } from '@sweetalert2/ngx-sweetalert2';

import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { errorHandlerInterceptor } from './services/error-handler.service';
import { CurrencyPipe, DecimalPipe, DatePipe } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    FullLoaderComponent,
    ToastModule,
  ],
  providers: [
    provideServiceWorker('ngsw-worker.js', {
      enabled: !['localhost', '127.0.0.1'].includes(location.hostname),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    KeycloakService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: KeycloakBearerInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorHandlerInterceptor,
    //   multi: true,
    // },
    provideSweetAlert2({
      fireOnInit: false,
      dismissOnDestroy: true,
    }),
    MessageService,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
